import A1 from "./A1.jpg"
import A2 from "./A2.jpg"
import A3 from "./A3.jpg"
import A4 from "./A4.jpg"
import A5 from "./A5.jpg"
import A6 from "./A6.jpg"
import A7 from "./A7.jpg"
import A8 from "./A8.jpg"
import A9 from "./A9.jpg"
import A10 from "./A10.jpg"
import A11 from "./A11.jpg"
import A12 from "./A12.JPG"
import A13 from "./A13.JPG"
import A14 from "./A14.JPG"
import A15 from "./A15.mp4"
import A16 from "./A16.png"
import A17 from "./A17.png"
import A18 from "./A18.png"
import A19 from "./A19.png"
import A20 from "./A20.JPG"












export const AboutImgs = {
    A1,
    A2,
    A3,
    A4,
    A5,
    A6,
    A7,
    A8,
    A9,
    A10,
    A11,
    A12,
    A13,
    A14,
    A15,
    A16,
    A17,
    A18,
    A19,
    A20,
}

